import { IconSvgProps } from '../types';

export const Stickers = ({ size }: IconSvgProps) => (
  <svg
    id="icon-object-stickers"
    width={size}
    height={size}
    viewBox="0 0 65 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path d="M0.04,32 C0.04,49.7 14.36,64 32.04,64 C32.04,46.3 46.36,32 64.04,32 C64.04,14.3 49.71,0 32.04,0 C14.36,0 0.04,14.3 0.04,32 Z" />
        <path
          d="M64.04,32 L32.04,64 C32.04,46.3 46.36,32 64.04,32 Z"
          opacity="0.5"
        />
      </g>
    </g>
  </svg>
);
